export default "/images/42c33ed340f29873eda313168858a397.avif";